module.exports = require("./th.js");